var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2626_25207)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2681 2.1804L19.983 15.5421C20.4015 16.2662 20.4015 17.0947 19.983 17.819C19.5645 18.5432 18.8471 18.9574 18.011 18.9574L2.58213 18.9582C1.74595 18.9582 1.02779 18.5439 0.610126 17.8198C0.192458 17.0957 0.192458 16.2672 0.610126 15.543L8.32412 2.18038C8.74263 1.45627 9.45996 1.04199 10.2961 1.04199C11.1323 1.04199 11.8505 1.45627 12.2681 2.1804ZM11.2342 6.74412V5.80693H9.35893V12.9089H11.2342V6.74412ZM11.2342 15.0549V14.1168H9.35893V15.9921H11.2342V15.0549Z",
    fill: "#F4BB66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2626_25207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.296875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogWarningIcon);
export default __webpack_public_path__ + "static/media/Log-warning-icon.547c29e32af168809c81dc51c342a563.svg";
export { ForwardRef as ReactComponent };